(() => {
  const money = (cents, currency = document.documentElement.lang === 'tr' ? 'TRY' : 'USD') =>
    new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style: 'currency', currency }).format(cents / 100);

  const drawer = document.querySelector('[data-cart-drawer]');
  const cartContent = document.querySelector('[data-cart-content]');
  const cartFooter = document.querySelector('[data-cart-footer]');

  async function getCart() {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Your cart could not be loaded.');
    return response.json();
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    if (!cart.item_count) {
      cartContent.innerHTML = '<p class="muted">Your cart is currently empty.</p>';
      cartFooter.hidden = true;
      return;
    }
    cartContent.innerHTML = cart.items.map((item) => `
      <article class="cart-item">
        ${item.image ? `<img src="${item.image}" alt="">` : '<div></div>'}
        <div><h3>${item.product_title}</h3><p>${item.variant_title || ''} · Qty ${item.quantity}</p></div>
        <strong>${money(item.final_line_price, cart.currency)}</strong>
      </article>`).join('');
    document.querySelector('[data-cart-total]').textContent = money(cart.total_price, cart.currency);
    cartFooter.hidden = false;
  }

  async function openCart() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    try { renderCart(await getCart()); } catch (error) { cartContent.textContent = error.message; }
  }

  function closeCart() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
  }

  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (event.submitter?.classList.contains('shopify-payment-button__button')) return;
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      const status = form.querySelector('[data-form-status]');
      const original = submit.textContent;
      submit.disabled = true;
      submit.textContent = 'Adding…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'The item could not be added.');
        status.textContent = 'Added to your cart.';
        await openCart();
      } catch (error) {
        status.textContent = error.message;
      } finally {
        submit.disabled = false;
        submit.textContent = original;
      }
    });
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting) entry.target.classList.add('is-visible'); });
  }, { threshold: .12 });
  document.querySelectorAll('.reveal').forEach((element, index) => {
    element.style.setProperty('--reveal-delay', `${Math.min(index % 5, 4) * 70}ms`);
    observer.observe(element);
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const scope = select.closest('[data-product-scope]') || document;
      const image = scope.querySelector('[data-variant-image], #ProductMainImage');
      if (image && option.dataset.imageSrc) {
        image.classList.add('is-changing');
        image.src = option.dataset.imageSrc;
        image.removeAttribute('srcset');
        image.alt = option.dataset.imageAlt || '';
        requestAnimationFrame(() => requestAnimationFrame(() => image.classList.remove('is-changing')));
      }
      const colorLabel = scope.querySelector('[data-selected-color]');
      if (colorLabel) colorLabel.textContent = option.dataset.colorLabel || option.textContent.split('—')[0].trim();
      const price = scope.querySelector('[data-variant-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      const compare = scope.querySelector('[data-variant-compare]');
      if (compare) {
        compare.textContent = option.dataset.comparePrice || '';
        compare.hidden = !option.dataset.comparePrice;
      }
      const addButton = scope.querySelector('[data-add-to-cart]');
      if (addButton) {
        const available = option.dataset.available !== 'false';
        addButton.disabled = !available;
        addButton.textContent = available ? (scope.classList.contains('product-page') ? 'Add to cart →' : 'Add to cart') : 'Sold out';
      }
      if (option.dataset.imageId) {
        scope.querySelectorAll('[data-product-gallery-thumbnail]').forEach((thumbnail) => {
          const active = thumbnail.dataset.imageId === option.dataset.imageId;
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-pressed', String(active));
        });
      }
    });
  });

  const mainProductImage = document.querySelector('#ProductMainImage');
  document.querySelectorAll('[data-product-gallery-thumbnail]').forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      if (!mainProductImage) return;
      mainProductImage.src = thumbnail.dataset.imageSrc;
      mainProductImage.removeAttribute('srcset');
      mainProductImage.alt = thumbnail.dataset.imageAlt || '';
      document.querySelectorAll('[data-product-gallery-thumbnail]').forEach((item) => {
        const active = item === thumbnail;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    });
  });

  const tilt = document.querySelector('[data-tilt]');
  if (tilt && matchMedia('(pointer:fine) and (prefers-reduced-motion:no-preference)').matches) {
    tilt.closest('.hero__visual')?.addEventListener('pointermove', (event) => {
      const rect = event.currentTarget.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - .5;
      const y = (event.clientY - rect.top) / rect.height - .5;
      tilt.style.transform = `rotateY(${x * 8}deg) rotateX(${y * -8}deg) rotate(2deg)`;
    });
    tilt.closest('.hero__visual')?.addEventListener('pointerleave', () => { tilt.style.transform = 'rotate(2deg)'; });
  }

  document.querySelector('[data-menu-toggle]')?.addEventListener('click', (event) => {
    const header = event.currentTarget.closest('.site-header');
    const open = header.classList.toggle('is-menu-open');
    event.currentTarget.setAttribute('aria-expanded', String(open));
  });
})();
